export default {
  collapse: {
    tooltip: {
      notes: 'Tooltip for button which collapses sidebar to rail',
      message: 'Collapse',
    },
  },
  expand: {
    tooltip: {
      notes: 'Tooltip for button which expands rail to sidebar',
      message: 'Expand',
    },
  },
};
